module.exports = __webpack_public_path__ + "img/office-desk.0e42fbce.svg";